import { autoinject, transient } from "aurelia-dependency-injection";
import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";
import { AcceptanceEmailModel, AdditionalEmailToNotifyModel, InspectionCompanyResendEmailModel, InspectorResendEmailModel, InspectorType, ResendAcceptanceEmailModel, RightShipInspectionClientModel } from "../../../../../../models/rightship-inspections/rightship-inspections.models";
import { NotificationClientService, NotificationType } from "@rightship-tech/common-ui/services/basic/notification-client.service";
import { RightShipInspectionsService } from "../../../../../../services/rightship-inspections/rightship-inspections.service";

@transient()
@autoinject
export class ResendAcceptanceEmailDialog {

    public inspection: RightShipInspectionClientModel;
    public assignment: ResendAcceptanceEmailModel;
    public isTechnicalManager: boolean = false;
    public isCorrespondence: boolean = false;
    public isTrainee: boolean = false;
    public inspectorEmailModels: InspectorResendEmailModel[] = [];
    public inspectionCompanyEmailModels: InspectionCompanyResendEmailModel[] = [];
    public additionalEmailToNotify: AdditionalEmailToNotifyModel[] = [];
    public traineeEmail: string;l

    constructor(private dialogClientService: DialogClientService, private notificationClientService: NotificationClientService,
        private rightshipInspectionService: RightShipInspectionsService
    ) {

    }

    activate(model: { assignment: ResendAcceptanceEmailModel })
    {
        this.assignment = model.assignment;
        this.inspectorEmailModels = this.assignment.assignedInspectors.filter(x => !x.isTrainee).map(x => {
            return { inspectorEmail: x.email, isSelected: false };
        });
        
        this.traineeEmail = this.assignment.assignedInspectors.filter(x => x.isTrainee).length == 1 ? 
            this.assignment.assignedInspectors.filter(x => x.isTrainee).map(x => x.email)[0] : "";
        
        if (this.assignment.inspectionCompanyEmails) {
            this.inspectionCompanyEmailModels = this.assignment.inspectionCompanyEmails.split(";").map(x => {
                return { inspectionCompanyEmail: x.trim(), isSelected: false };
            });
        }
        
        if (this.assignment.additionalEmails) {
            this.additionalEmailToNotify = this.assignment.additionalEmails.split(";").map(x => {
                return { emailToNotify: x.trim(), isSelected: false };
            });
        }
    }

    close() {
        this.dialogClientService.hide(true);
    }

    private getSelectedEmails(): AcceptanceEmailModel[] {
        const request: AcceptanceEmailModel[] = [];
        this.inspectorEmailModels.forEach(x => {
            if (x.isSelected) {
                request.push({
                    email: x.inspectorEmail,
                    inspectorType: InspectorType.Inspector
                });
            }
        });

        this.inspectionCompanyEmailModels.forEach(x => {
            if (x.isSelected) {
                request.push({
                    email: x.inspectionCompanyEmail,
                    inspectorType: InspectorType.InspectionCompany
                });
            }
        });

        this.additionalEmailToNotify.forEach(x => {
            if (x.isSelected) {
                request.push({
                    email: x.emailToNotify,
                    inspectorType: InspectorType.TechnicalManager
                });
            }
        });

        if (this.isTrainee) {
            request.push({
                email: this.traineeEmail,
                inspectorType: InspectorType.Trainee
            });
        }

        if (this.isCorrespondence) {
            request.push({
                email: this.assignment.correspondenceEmail,
                inspectorType: InspectorType.Correspondence
            });
        }

        if (this.isTechnicalManager) {
            request.push({
                email: this.assignment.technicalManagerEmail,
                inspectorType: InspectorType.TechnicalManager
            });
        }
        return request;
    }

    async proceed()
    {
        const selectedEmails = this.getSelectedEmails();
        if (selectedEmails.length == 0) {
            this.notificationClientService.show("Error", "Please select at least one email to resend", NotificationType.Error);
            return;
        }
        try {
            this.rightshipInspectionService.resendAcceptanceEmails({
                rightShipInspectionId: this.assignment.rightShipInspectionId,
                rightShipInspectionInspectorAssignmentId: this.assignment.rightShipInspectionAssignmentId,
                emailsToSend: selectedEmails
            });
            this.close();
        } catch (e) {            
            this.notificationClientService.show("Error", "Resend Acceptance Email Failed", NotificationType.Error);
        }
    }
}